import { emptyArr, emptyObj } from '@beef/utils';
import { getSharedData } from "../catalogSelectors";
export var getBreadcrumbsData = function getBreadcrumbsData(state) {
  return getSharedData(state).breadcrumbs || emptyArr;
};
export var getCallbackRequestData = function getCallbackRequestData(state) {
  return getSharedData(state).callbackRequestData || emptyObj;
};
export var getPageSettings = function getPageSettings(state) {
  return getSharedData(state).pageSettings || emptyObj;
};
export var getSelfCallingPopupData = function getSelfCallingPopupData(state) {
  return getSharedData(state).selfCallingPopupData || emptyObj;
};
export var getPageType = function getPageType(state) {
  return getPageSettings(state).pageType;
};
export var getIsAuthFlag = function getIsAuthFlag(state) {
  return getPageSettings(state).isAuth;
};
export var getUserData = function getUserData(state) {
  return getSharedData(state).userData || emptyObj;
};
export var getUserType = function getUserType(state) {
  return getUserData(state).userType;
};